module.exports = {"130633100":"易州镇","130633101":"梁格庄镇","130633102":"西陵镇","130633103":"裴山镇","130633104":"塘湖镇","130633105":"狼牙山镇","130633106":"良岗镇","130633107":"紫荆关镇","130633108":"高村镇","130633200":"桥头乡","130633201":"白马乡","130633202":"流井乡","130633204":"高陌乡","130633205":"大龙华乡","130633206":"安格庄乡","130633207":"凌云册乡","130633208":"西山北乡","130633209":"尉都乡","130633210":"独乐乡","130633211":"七峪乡","130633212":"富岗乡","130633213":"坡仓乡","130633214":"牛岗乡","130633215":"桥家河乡","130633216":"甘河净乡","130633217":"蔡家峪乡","130633218":"南城司乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130633.json
// module id = 166
// module chunks = 0